import z from 'zod';
import { partySchema } from '../../common';

export const orderPODCopyStatusSchema = z.enum([
  'no_pod_required', // image required but no return is required
  'not_received', // pod with carrier
  'received',
  'under_review',
  'ready_to_be_sent',
  'sent',
  'delivered',
]);
/**
 * the proof of delivery status
 */
export type OrderPODStatus = z.infer<typeof orderPODCopyStatusSchema>;

/**
 * Phase 7 (relations-v2): flipped from {@link relationSchema} to a
 * {@link partySchema} snapshot. See {@link orderOwnerSchema}.
 */
export const orderPODOwnerSchema = partySchema;

export type OrderPODOwner = z.infer<typeof orderPODOwnerSchema>;


export const orderPODImageStatusSchema = z.enum(['waiting_for_upload', 'uploaded', 'complete', 'not_required'])
export type OrderPODImageStatus = z.infer<typeof orderPODImageStatusSchema>;